/* eslint-disable arrow-parens */
/* eslint-disable quotes */
import React, { Component } from "react";
import PropTypes from "prop-types";

import i18n from "i18n-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { HashLink as Link } from "react-router-hash-link";
import { Spring } from "react-spring";
import { ToastContainer, toast, cssTransition } from "react-toastify";

import SearchInput from "components/SearchModal/SearchInput";

import {
  baseAppId,
  storageKeys,
  bgVideo,
  destination,
  graduateTitle,
} from "settings";

import {
  APIHandler,
  StorageHandler,
  BackVideo,
  DataHandler,
  StoreButtons,
  SweetAlert,
  LanguageSelect,
} from "C4";

import "react-toastify/dist/ReactToastify.css";

const Zoom = cssTransition({
  enter: "zoomIn",
  exit: "zoomOut",
  duration: [500, 800],
});

export default class HomeView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      query: "",
      unreadMessageCount: 0,
      lastCheckedMessages: "1993-01-10",
      appId: -1,
      userStatus: "startTraining",
      noAgent: false,
      germanVersion: false,
      popup: false,
      openMessage: false,
      messagePopup: {},
      logo: null,
      landingQuote: null,
    };

    this.close = this.close.bind(this);
  }

  componentWillMount() {
    document.body.classList.add("no-scroll");

    StorageHandler.load(storageKeys.user).then((res) => {
      if (res.training_graduated) {
        return this.setState({ userStatus: "graduated" });
      }
      if (res.training_started) {
        return this.setState({ userStatus: "continueTraining" });
      }
      return this.setState({ userStatus: "startTraining" });
    });

    this.checkForUnreadMessages();
  }

  componentDidMount() {
    const d = new Date(Date.now());
    const leading = (val) => `0${val}`.slice(-2);

    StorageHandler.load(storageKeys.user).then((user) => {
      if (user && user.sales_companion_registered === null) {
        const obj = user;
        const date = `${d.getFullYear()}-${leading(d.getMonth() + 1)}-${leading(
          d.getDate()
        )}`;
        DataHandler.matchAppId().then((appId) => {
          APIHandler.updateUser(appId, obj.email, [
            { param: "sales_companion_registered", val: date },
          ]).then((res) => {
            if (res) {
              obj.sales_companion_registered = date;
              StorageHandler.save(storageKeys.user, obj);
            }
          });
        });
      }
    });

    DataHandler.matchAppId().then((appId) => {
      this.setState({ appId });
      APIHandler.getAnnouncement(appId).then((res) => {
        this.setState({ messagePopup: res[0] });
        console.log(res[0]);

        const ToastContent = () => (
          <div
            onClick={() => {
              this.openPopup();
            }}
            dangerouslySetInnerHTML={{ __html: res[0].message }}
          />
        );

        if (res.length !== 0) {
          toast.info(ToastContent, {
            position: "top-center",
            autoClose: false,
            transition: Zoom,
            hideProgressBar: true,
            pauseOnHover: true,
            draggable: true,
            toastId: "announcement",
          });
        }
        return null;
      });
    });

    this.getAppInfo();
  }

  componentWillUnmount() {
    document.body.classList.remove("no-scroll");
  }

  setQuery() {
    const { query } = this.state;
    if (query.length > 0) {
      StorageHandler.save(storageKeys.lastSearchQuery, query);
    }
  }

  async getAppInfo() {
    const appInfo = await StorageHandler.load(storageKeys.appInfo);
    if (appInfo) {
      this.setState({
        logo: appInfo.logoWhite,
        landingQuote: appInfo.landingQuote,
      });
    }
  }

  close() {
    this.setState({
      popup: false,
    });
  }

  openPopup() {
    this.setState({
      openMessage: true,
    });
  }

  checkForUnreadMessages() {
    StorageHandler.load(storageKeys.lastCheckedMessage).then((res) => {
      if (res) {
        DataHandler.requestWithId(APIHandler.getUnreadMessages, res).then(
          (res) => {
            this.setState({ unreadMessageCount: res.missed_items[0].count });
          }
        );
      } else {
        DataHandler.requestWithId(
          APIHandler.getUnreadMessages,
          "1993-01-10"
        ).then((res) => {
          this.setState({ unreadMessageCount: res.missed_items[0].count });
        });
      }
    });
  }

  render() {
    const {
      unreadMessageCount,
      popup,
      logo,
      landingQuote,
      messagePopup,
      openMessage,
    } = this.state;

    const open = () => {
      this.setState({
        popup: true,
      });
    };

    return (
      <div className="homeContainer">
        {bgVideo && <BackVideo darken />}
        <div className="bgHome" />
        <div className="buttonWrapper">
          Download now:
          <StoreButtons />
        </div>
        <LanguageSelect />
        <div className="swoop" />
        <Spring
          from={{ transform: "translateY(30%)", opacity: 0 }}
          to={{ transform: "translateY(0%)", opacity: 1 }}
        >
          {(props) => (
            <div className="homeView" style={props}>
              <div className="homeView__title">
                <img src={logo} className="homeLogo" alt="logo" />
                {/* <h1 className="subtitle">{landingQuote}</h1> */}
                <div className="homeView__title--action">
                  <SearchInput />
                  <div className="homepage__buttons">
                    <Link to="/main/messages" className="messageBtn">
                      <FontAwesomeIcon icon={["fas", "envelope"]} />
                      {unreadMessageCount === 0 && (
                        <p>{i18n.translate("nav.messages")}</p>
                      )}
                      {unreadMessageCount > 0 && (
                        <p>
                          {i18n.translate(
                            `${
                              unreadMessageCount === 1
                                ? "general.message"
                                : "general.messagePlural"
                            }`,
                            { count: unreadMessageCount }
                          )}
                        </p>
                      )}
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          )}
        </Spring>
        {/* <div className="top-bar" />
        <div className="bottom-bar" />*/}
        <div className="bottom-bg" />
        <div className="bottomLine" />

        {/* <SweetAlert
          title="This feature is Coming Soon"
          show={noAgent}
          imageUrl={Logo2}
          imageWidth="50rem"
          imageHeight="50rem"
          html
          text=""
          customClass="noAgent"
          showConfirmButton={false}
          cancelButtonText={i18n.translate("close")}
          showCancelButton
          onConfirm={close}
          onCancel={close}
          onEscapeKey={close}
          onOutsideClick={close}
        /> */}
        <SweetAlert
          title=""
          trigger={popup}
          {...{
            title: "",
            html: `Rewards are available once you receive your diploma as a certified ${destination} ${graduateTitle}. Please complete the Learning chapters and come back to submit your bookings.`,
            confirmButtonText: i18n.translate("general.close"),
            onClose: this.close,
          }}
        />
        <ToastContainer
          draggablePercent={60}
          autoClose={false}
          newestOnTop
          rtl={false}
          pauseOnVisibilityChange
          draggable
        />
        {/* {messagePopup.message && (
          <SweetAlert
            title={messagePopup.message}
            html={messagePopup.messagePopUp}
            trigger={openMessage}
            showConfirmButton={false}
            cancelButtonText={i18n.translate("general.close")}
            showCancelButton
            customClass="homePopup"
          />
        )} */}
      </div>
    );
  }
}
